import {
	Popover,
	Box,
	Divider,
	FormGroup,
	FormControlLabel,
	Checkbox,
	Stack,
	Button,
	Typography,
} from '@mui/material'
import CheckBoxCustom from '../atoms/checkbox/CheckBox'
import ButtonCustom from '../atoms/button/ButtonCustom'
import { useState } from 'react';

const statusFilters = [
  { id: 'all', label: 'All Categories' },
  { id: 'Upcoming', label: 'Upcoming' },
  { id: 'Active', label: 'Active' },
  { id: 'Completed', label: 'Completed' },
];

export default function FilterPopover({
	page,
	anchorEl,
	open,
	onClose,
	sections = [],
	onClear,
	onApply,
	paperProps,
	weddingsMockData,
	selectedWeddings = [],
	onToggleWedding,
	isAllSelected = false,
	onToggleAllWeddings,
	title = 'Filters',
	clearLabel = 'Clear',
	applyLabel = 'Apply',
}) {
  const [selectedStatus, setSelectedStatus] = useState('all');
  
  const handleStatusFilter = (status) => {
    setSelectedStatus(status);
    if (status === 'all') {
      // Select all weddings
      onToggleAllWeddings?.(true);
    } else {
      // Select only weddings with matching status
      const weddingsToSelect = weddingsMockData.filter(wedding => wedding.status === status);
      // First clear all selections
      selectedWeddings.forEach(wedding => {
        onToggleWedding?.(wedding, false);
      });
      // Then select matching weddings
      weddingsToSelect.forEach(wedding => {
        onToggleWedding?.(wedding, true);
      });
    }
  };
	const filter_style = {
		marginTop: '3px',
		'& .MuiPaper-root': {
			boxShadow: '0px 0px 4px 0px #00000040',
			border: '1px solid #DFE4EB',
			borderRadius: '12px',
			// width: '240px',
			width: 'max-content',
			maxWidth: '310px',
		},
	}

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			PaperProps={{ sx: { p: 2, width: 280 }, ...paperProps }}
			sx={filter_style}
		>
			<Box
				sx={{
					fontSize: '14px',
					color: '#313131',
					fontWeight: 500,
					mb: '8px',
					fontFamily: 'Inter',
					textTransform: 'capitalize',
				}}
			>
				{title}
			</Box>

			{page === 'planner-timeline' && (
				<>
					<Box
						className="allCategories"
						sx={{
							display: 'flex',
							flexWrap: 'wrap',
							alignItems: 'center',
							gap: '5px',
							margin: '10px 0',
						}}
					>
			{statusFilters.map((filter) => (
				<ButtonCustom 
					key={filter.id}
					variant="outlined"
					size="sm"
					sx={{
					backgroundColor: selectedStatus === filter.id ? '#7CA6BD' : 'transparent',
					color: selectedStatus === filter.id ? '#fff' : 'inherit',
					'&:hover': {
						backgroundColor: selectedStatus === filter.id ? '#6c95a9' : 'rgba(0, 0, 0, 0.04)'
					},
					borderColor: '#DFE4EB',
					minWidth: 'auto',
					padding: '6px 12px'
					}}
					onClick={() => handleStatusFilter(filter.id)}
				>
					{filter.label}
				</ButtonCustom>
           	))}
					</Box>

					<div
						style={{
							margin: '1rem 0',
						}}
					>
						<div
							style={{
								paddingBottom: '8px',
							}}
						>
							<CheckBoxCustom
								size="20px"
								checked={isAllSelected}
								onChange={(e) => onToggleAllWeddings?.(e.target.checked)}
								label={
									<div>
										<h3
											style={{
												fontSize: '14px',
												fontWeight: 400,
											}}
										>
											Select all Weddings
										</h3>
									</div>
								}
							/>
						</div>

						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								gap: '8px',
								padding: '8px 0',
								borderTop: '1px solid #DFE4EB',
								borderBottom: '1px solid #DFE4EB',
								maxHeight: '160px',
								overflowY: 'auto',
							}}
						>
							{weddingsMockData.map((item, index) => (
								<div
									key={index}
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										padding: '4px 8px',
										borderRadius: '8px',
									}}
								>
									{/* Left section */}
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											gap: '8px',
											width: '100%',
										}}
									>
										<CheckBoxCustom
											size="18px"
											checked={selectedWeddings.some(
												(w) => w.name === item.name
											)}
											onChange={(e) =>
												onToggleWedding?.(item, e.target.checked)
											}
											label={
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'space-between',
														gap: '8px',
													}}
												>
													<div
														style={{
															width: '10px',
															height: '10px',
															borderRadius: '50%',
															backgroundColor:
																item.color,
														}}
													/>
													<span
														style={{
															fontWeight: 500,
															fontSize: '14px',
														}}
													>
														{item.name}
													</span>
												</div>
											}
										/>

										<ButtonCustom
											variant="secondary"
											size="sm"
										>
											{item.status}
										</ButtonCustom>
									</div>
								</div>
							))}
						</div>
					</div>
				</>
			)}

			{page !== 'planner-timeline' &&
				sections.map((sec, i) => (
					<Box
						key={sec.id}
						sx={{
							'&.MuiBox-root': {
								mb: '8px',
								borderBottom: '1px solid #DFE4EB',
							},
						}}
					>
						<Typography
							variant="h6"
							sx={{
								fontSize: '12px',
								color: '#8692A4',
								fontWeight: 400,
								mb: '8px',
								fontFamily: 'Inter',
								textTransform: 'capitalize',
							}}
						>
							{sec.title}
						</Typography>
						<FormGroup
							sx={{
								mb: 1,
								maxHeight: 160,
								overflow: 'auto',
								gap: '10px',
							}}
						>
							{sec.options.map((opt) => {
								const val =
									typeof opt === 'string' ? opt : opt.value
								const label =
									typeof opt === 'string' ? opt : opt.label
								const checked = sec.selected?.includes(val)
								return (
									<CheckBoxCustom
										label={label}
										key={val}
										checked={checked}
										onChange={(e) =>
											sec.onToggle?.(
												val,
												e.target.checked
											)
										}
									/>
								)
							})}
						</FormGroup>
					</Box>
				))}

			<Stack direction="row" spacing={1} justifyContent="flex-end">
				<ButtonCustom
					onClick={onClear}
					variant="outlined"
					size="sm"
					style={{ fontWeight: '500' }}
				>
					{clearLabel}
				</ButtonCustom>
				<ButtonCustom
					onClick={onApply}
					variant="default"
					size="sm"
					style={{ fontWeight: '500' }}
				>
					{applyLabel}
				</ButtonCustom>
			</Stack>
		</Popover>
	)
}
